export type OrganisatieUserRole = 'admin' | 'keyUser' | 'user' | 'readonlyUser';

export const organisatieUserRoleLabels: Record<OrganisatieUserRole, string> = {
  admin: 'Administrator',
  keyUser: 'Beheerder',
  user: 'Gebruiker',
  readonlyUser: 'Alleen lezen',
};

export const inviteRoleOptions: OrganisatieUserRole[] = ['user', 'readonlyUser', 'keyUser'];

export const updateRoleOptions: OrganisatieUserRole[] = ['user', 'readonlyUser', 'keyUser'];

export const getRoleLabel = (role: OrganisatieUserRole): string => organisatieUserRoleLabels[role];

export const toNavigationRole = (role: OrganisatieUserRole): 'Admin' | 'KeyUser' | 'User' | 'ReadOnly' => {
  switch (role) {
    case 'admin':
      return 'Admin';
    case 'keyUser':
      return 'KeyUser';
    case 'readonlyUser':
      return 'ReadOnly';
    case 'user':
    default:
      return 'User';
  }
};

export const getDefaultRoleFromLegacyFlag = (legacyKeyUser?: boolean): OrganisatieUserRole => (
  legacyKeyUser ? 'keyUser' : 'user'
);